/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as bootstrap from 'bootstrap';
// components
import Table from '../../components/Table';

import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { Modal, Button, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { getFeedback, getNotification } from '../../API/RDPMS_API';
import moment from 'moment';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import { FormInput } from '../../components';
import config from '../../config';
const baseUrl = config.RDPMS_IMAGE_URL;

const Notification = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    let stationIds = [sessionStorage.getItem('stationId')];

    const navigate = useNavigate();

    const [stationsName, setStationsName] = useState(sessionStorage.getItem('stationName'));
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedDevice, setselectedDevice] = useState('All');
    const [device, setDevice] = useState([
        'All',
        'DC Circuit',
        'HASSDAC',
        'Point Machine',
        'Signal',
        'Batteries',
        'IPS',
    ]);
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const [feedback, setFeedback] = useState([]);
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [selectedProductImgs, setSelectedProductImgs] = useState({});
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    useEffect(() => {
        getNotificationData();
    }, []);

    const { t } = useTranslation();

    const getNotificationData = async (limits, pages, device) => {
        Loading();
        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;
        let selectedDevices = device ? device : selectedDevice;

        let request = {
            limit: limitNumber,
            page: pagesNumber,
            stationId: stationIds,
            selectedDevice: selectedDevices,
        };

        let response = await getNotification(request);
        // console.log(response, 'response......');

        if (response && response.data && response.data.length > 0) {
            let srNo = pagesNumber * limitNumber - limitNumber + 1;
            let dataArray = await response.data.map((t) => {
                t.srNo = srNo++;
                return {
                    srNo: t.srNo,
                    id: t._id,
                    archiveId: t.archive_id,
                    deviceType: t.device_name,
                    time: moment(t.time).format('Do MMM YYYY, h:mm a'),
                    stationName: stationsName,
                    deviceName: t.name,
                    deviceId: t.device_id,
                    // attribute: t.attribute_name,
                    // actualValue: t.actual_value,
                    // min: t.min_value,
                    // max: t.max_value,
                    message: t.archive_id ? 'Data not in limits' : 'No data received',
                    read: t.is_read ? <i className="uil-check-circle" style={{ fontSize: '18px' }}></i> : '',
                    feedback: t.archive_id ? (
                        <div>
                            <i className="dripicons-preview" onClick={() => viewFeedback(t)}></i>
                        </div>
                    ) : (
                        ''
                    ),
                };
            });

            // setDevice(deviceName);

            setPageNumber(response.currentPage);
            setPageCount(response.totalPages);
            setData(dataArray);
            setTotalCount(response.totalCount);

            setStatusMessage('Alerts fetched successfully for ' + selectedDevices + ' device');
            const statusModal = new bootstrap.Modal(document.getElementById('statusModal'));
            statusModal.show();

            setTimeout(() => {
                statusModal.hide();
            }, 3000);
        } else {
            setStatusMessage('No data found for ' + selectedDevices + ' device');
            const statusModal = new bootstrap.Modal(document.getElementById('statusModal'));
            statusModal.show();

            setTimeout(() => {
                statusModal.hide();
            }, 3000);
        }
        Loading();
    };

    const viewFeedback = async (value) => {
        const request = {
            archievesId: value.archive_id,
            masterId: value.master_id,
            stationId: value.station_id,
            notificationId: value._id,
        };
        let response = await getFeedback(request);

        if (response && response.length > 0) {
            setFeedback(response);
            setShowFeedbackModal(true);

            const initialImages = response.reduce((acc, item, index) => {
                acc[index] = item.file_name.length > 0 ? baseUrl + item.file_name[0] : '';
                return acc;
            }, {});
            setSelectedProductImgs(initialImages);
        } else {
            toast.error('No feedback data found', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getNotificationData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getNotificationData(limit, value);
    };

    /*
     * handle date change
     */
    const onDateChange = (date) => {
        if (date) {
            setSelectedDate(date);
        }
    };

    const handleDevice = (e) => {
        setselectedDevice(e.target.value);
        getNotificationData(5, 1, e.target.value);
    };

    const columns = [
        {
            Header: t('Id'),
            accessor: 'srNo',
            sort: false,
        },
        {
            Header: t('Time'),
            accessor: 'time',
            sort: false,
        },
        {
            Header: t('Device Type'),
            accessor: 'deviceType',
            sort: true,
        },
        {
            Header: t('Station Name'),
            accessor: 'stationName',
            sort: true,
        },
        {
            Header: t('Device Name'),
            accessor: 'deviceName',
            sort: true,
        },
        {
            Header: t('Device ID'),
            accessor: 'deviceId',
            sort: false,
        },
        // {
        //     Header: t('Attribute Name'),
        //     accessor: 'attribute',
        //     sort: false,
        // },

        // {
        //     Header: t('Actual Value'),
        //     accessor: 'actualValue',
        //     sort: false,
        // },

        // {
        //     Header: t('Minimum'),
        //     accessor: 'min',
        //     sort: false,
        // },

        // {
        //     Header: t('Maximum'),
        //     accessor: 'max',
        //     sort: false,
        // },

        {
            Header: t('Message'),
            accessor: 'message',
            sort: false,
        },
        // {
        //     Header: t('View'),
        //     accessor: 'view',
        //     sort: false,
        // },
        {
            Header: t('Read'),
            accessor: 'read',
            sort: true,
        },
        {
            Header: t('Feedback'),
            accessor: 'feedback',
            sort: false,
        },
    ];

    const sizePerPageList = [
        {
            text: '5',
            value: 5,
        },
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: '50',
            value: 50,
        },
    ];

    const feedbackCloseModalWithHeaderClass = () => {
        setShowFeedbackModal(false);
        setFeedback([]);
    };

    /**
     * Handles the image changes
     */
    const handleImgChange = (e, src, index) => {
        e.preventDefault();
        setSelectedProductImgs((prevState) => ({
            ...prevState,
            [index]: src,
        }));
    };

    return (
        <>
            <ToastContainer />

            <div className=" py-3 " style={{ width: '100%' }}>
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        {/* Alerts Overview Button */}
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                {t('All Notification')}
                            </button>
                        </div>

                        {/* Dropdown and Update Button */}
                        <div className="col-12 col-md-auto ms-md-auto">
                            <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-5">
                                {/* Dropdown */}
                                <div className="flex-grow-1">
                                    <FormInput
                                        className="btn dropdown-button d-flex justify-content-between align-items-center w-100"
                                        name="select"
                                        type="select"
                                        key="select"
                                        onChange={(e) => handleDevice(e)}>
                                        {device &&
                                            device.map((item, index) => (
                                                <option
                                                    key={index}
                                                    className="dropdown-item dropdown-item-custom dropdown-toggle-icon-all"
                                                    value={item}>
                                                    {t(item)}
                                                </option>
                                            ))}
                                    </FormInput>
                                </div>

                                {/* Update Button */}
                                <button
                                    className="update d-flex align-items-center justify-content-center flex-grow-1"
                                    id="update">
                                    {t('Update')} <i className="mdi mdi-autorenew ms-1"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="col-sm-12 card-alerts my-4 p-3 border-0  text-start no-radius"
                    style={{ width: '100%', position: 'relative' }}>
                    <div className="row align-items-center">
                        {/* <div className="col-sm-6 text-start">1 results found</div> */}
                        {/* <div className="search_bar col-sm-6 ">
                                <input type="search" placeholder="search" />
                            </div> */}
                    </div>

                    <Table
                        columns={columns}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>

            <Modal
                show={showFeedbackModal}
                dialogClassName="modal-full-width"
                size="lg"
                onHide={feedbackCloseModalWithHeaderClass}>
                <Modal.Header
                    onHide={feedbackCloseModalWithHeaderClass}
                    closeButton
                    closeVariant="white"
                    className="modal-colored-header bg-primary">
                    <h4 className="modal-title text-light">{t('Feedback')}</h4>
                </Modal.Header>
                <Modal.Body>
                    {feedback.length > 0 &&
                        feedback.map((item, index) => {
                            return (
                                <Row key={index}>
                                    <Col>
                                        <Card>
                                            <Card.Body>
                                                <Row>
                                                    <Col lg={5}>
                                                        <div
                                                            className="d-flex justify-content-center align-items-center mb-4 border"
                                                            style={{
                                                                width: '100%',
                                                                height: '300px',
                                                                overflow: 'hidden',
                                                                backgroundColor: '#f9f9f9',
                                                            }}>
                                                            {selectedProductImgs[index] !== '' ? (
                                                                <img
                                                                    src={selectedProductImgs[index]}
                                                                    alt="Product"
                                                                    style={{
                                                                        maxHeight: '100%',
                                                                        maxWidth: '100%',
                                                                        objectFit: 'contain',
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div className="text-muted text-center w-100">
                                                                    {t('Image not selected')}
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="d-lg-flex d-none justify-content-center">
                                                            {item.file_name.map((imgs, ind) => {
                                                                return (
                                                                    <Link
                                                                        to="#"
                                                                        key={ind}
                                                                        onMouseOver={(e) => {
                                                                            handleImgChange(e, baseUrl + imgs, index);
                                                                        }}
                                                                        onClick={(e) => {
                                                                            handleImgChange(e, baseUrl + imgs, index);
                                                                        }}>
                                                                        <img
                                                                            src={baseUrl + imgs}
                                                                            className="img-fluid img-thumbnail p-2"
                                                                            style={{ maxWidth: '75px' }}
                                                                            alt="Product-img"
                                                                        />
                                                                    </Link>
                                                                );
                                                            })}
                                                        </div>
                                                    </Col>
                                                    <Col lg={7}>
                                                        <form className="ps-lg-4">
                                                            <h3 className="mt-0">{item.name}</h3>
                                                            <p className="mb-1">
                                                                {t('Added Date')}:{' '}
                                                                {moment(item.updatedAt).format('Do MMM, h:mm a')}
                                                            </p>

                                                            <p className="mb-1">
                                                                {t('Alert is')}: {item.alert}
                                                            </p>

                                                            <div className="mt-4">
                                                                <h6 className="font-14">{t('Description')}:</h6>
                                                                <p>{item.descriptions}</p>
                                                            </div>
                                                        </form>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            );
                        })}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={feedbackCloseModalWithHeaderClass}>
                        {t('Close')}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Success Modal for Alert Refresh */}
            {/* Status Modal (Success/Error without image) */}
            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notification;
